import React from 'react';
import { useGetShippingLines } from 'api/counterparties';
import {
  GetShippingLineParams,
  ShippingLine,
} from 'api/counterparties/counterparties.types';
import { EditableAutocomplete } from './EditableAutocomplete';

interface EditableShippingLineAutocompleteProps {
  value: any;
  onChange: (value: any) => void;
  onSave: (value: any) => void;
  onCancel: () => void;
  disableClearable?: boolean;
}

export const EditableShippingLineAutocomplete: React.FC<
  EditableShippingLineAutocompleteProps
> = ({ disableClearable = false, ...props }) => (
  <EditableAutocomplete<any, GetShippingLineParams>
    {...props}
    disableClearable={disableClearable}
    useApiHook={useGetShippingLines}
    getterName='getShippingLines'
    defaultParams={{
      filterText: '',
      resultSize: 25,
      pageNumber: 1,
    }}
    mapOptions={(data: ShippingLine[]) =>
      data.map((shippingLine) => ({
        businessFunctions: shippingLine.businessFunctions,
        id: shippingLine.id,
        code: shippingLine.code,
        enabled: shippingLine.businessFunctions.find(
          (businessFunction: any) => businessFunction.__type === 'ShippingLine',
        )?.enabled,
      }))
    }
    getOptionLabel={(option) =>
      option.code || option.counterpartyShortName || ''
    }
    isOptionEqualToValue={(option, selectedValue) =>
      selectedValue?.id === option?.id
    }
    width={undefined}
    deduplicateOptions={true}
    deduplicateKey='id'
  />
);
